import { router } from '@inertiajs/react';
import { useEffect } from 'react';

import { MixpanelEventName, MixpanelUtils } from '@/mixpanel';
import { User } from '@/types';

export const useMixpanelPageTrack = (user: User): void => {
  MixpanelUtils.initialize();

  MixpanelUtils.identify(user.pid);

  useEffect(() => {
    return router.on('navigate', () => {
      MixpanelUtils.track(MixpanelEventName.pageView, {
        url: window.location.pathname,
      });
    });
  }, []);
};
